import { useCallback, useMemo } from "react";
import UseCasesTabsComponent from "segments/desktop/tabs/layouts/use-cases-tabs/use-cases-tabs-component";
import Colors from "styles/colors";
import { componentStyles } from "./process-tabs-mobile.scss";

const ProcessTabsMobile = ({ tabs, tabsColor, autoTransition, titleConfig, tabBackgroundColor }) => {
  const getTabAssetFullParagraph = useCallback(
    (tab) => ({
      ...(tab.title || {}),
      topic: {},
      body: null,
      ...titleConfig,
      titleClassName: "asset-title"
    }),
    [titleConfig]
  );

  const mobileTabs = useMemo(
    () =>
      tabs.map((tab) => ({
        tabLabel: tab.tabLabel,
        tabContent: {
          asset: null,
          mobileAsset: tab.asset,
          images: [{ src: null, fullParagraph: getTabAssetFullParagraph(tab) }]
        }
      })),
    [getTabAssetFullParagraph, tabs]
  );

  return (
    <div
      className="process-tabs-mobile"
      style={{ "--tab-color": Colors[tabsColor], backgroundColor: tabBackgroundColor }}
    >
      <UseCasesTabsComponent tabs={mobileTabs} autoplaySpeed={autoTransition} />
      <style jsx>{componentStyles}</style>
    </div>
  );
};

export default ProcessTabsMobile;
